import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { getCurrentStep } from '../store/flow/selectors';
import { LOG } from './HttpRequester';
export const logEndpointTriggered = ({
  endpointKey,
  triggerAction,
  triggerReason,
  state
}) => {
  const currentStep = getCurrentStep(state);

  const {
    type
  } = triggerAction,
        actionData = _objectWithoutPropertiesLoose(triggerAction, ["type"]);

  const actionDetails = Object.keys(actionData).length === 0 ? '' : `\n\t\t${JSON.stringify(actionData)}`;
  const actionDescription = `${type}${actionDetails}`;
  LOG.debug(`\nEndpoint [ ${endpointKey} ] trigerred
    \tAction: ${actionDescription}
    \tReason: "${triggerReason}"
    \tAt current step: ${currentStep}
    `);
};